module.exports = __webpack_public_path__ + "img/logo.6f483c5a.png";